import React from 'react';
import { useTheme } from '@10d/tend-ui-theme';
import { Root } from './styled.js';

const Em = React.forwardRef((props, ref) => {
    return React.createElement(Root, Object.assign({ "data-testid": 'tend-ui-em' }, props, { ref: ref, theme: useTheme() }));
});
Em.displayName = 'Em';

export { Em };
//# sourceMappingURL=Em.js.map
